module.exports = __webpack_public_path__ + "img/block-magenta.8e9b4041.png";